<template>
  <input type="text" ref="inputEl" v-model="innerValue" @keyup="onKeyup" @focus="onFocus" @blur="onBlur" class="form-control" />
</template>

<script>
function formatNumber(number) {
  number = (number || '').toString().trim()

  // number = number.replace(/\D|\+/g, '');

  // const deleteKey = event ? (event.keyCode === 8 || event.keyCode === 46) : false;
  // const numberLength = number.length;

  // if (numberLength === 0) {
  //   number = number;
  // }

  return number
}

export default {
  name: 'tel-input',
  props: {
    value: String,
  },
  data() {
    return {
      innerValue: null,
    }
  },
  watch: {
    value() {
      this.innerValue = formatNumber(this.value)
    },
  },
  methods: {
    focus() {
      this.$refs.inputEl.focus()
    },
    onFocus() {
      this.$emit('focus')
    },
    onBlur() {
      this.$emit('blur')
    },
    onKeyup(event) {
      this.innerValue = formatNumber(this.innerValue, event)

      this.$emit('input', this.innerValue)
      this.$emit('change', this.innerValue)
    },
  },
  created() {
    this.innerValue = formatNumber(this.value)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TelInput.vue